import React from "react";

export default function PostLoader() {
  return <div className="postloader"></div>;
}
